import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { QuotationDeliverableForm } from '@teem/model-forms/quotation-deliverable-form';
import { QuotationDeliverable } from '@teem/models/quotation-deliverable';
import { SharedDataService } from '@teem/services/shared-data.service';
import { QuotationService } from '@teem/services/quotation.service';
import { ACTIONS as QUOTE_ACTIONS } from '@teem/constants/quotes';
import { QuotationForm } from '@teem/model-forms/quotation-form';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { client as ClientApi,general as GeneralAPI } from '@teem/constants/api';
import { UserService } from '@teem/services/user.service';
import { parseDate } from '@teem/helpers/functions';
import { Quotation } from '@teem/models/quotation';
import { Client } from '@teem/models/client';
import { Select2Directive } from "@teem/directives/select2.directive";
import { AddClientModalComponent } from '@teem/invoices-module/modals/add-client-modal/add-client-modal.component';

import { PaymentInfoModalComponent } from '@teem/quotes-module/modals/payment-info-modal/payment-info-modal.component';
import { QuotationLinkModalComponent } from '@teem/quotes-module/modals/quotation-link-modal/quotation-link-modal.component';
import { AddItemsComponent } from '@teem/quotes-module/modals/add-items/add-items.component';

@Component({
  selector: 'create-quotation',
  templateUrl: './create-quotation.component.html',
  styleUrls: ['./create-quotation.scss']
})
export class CreateQuotationComponent implements OnInit {

  @Output() onCreate: EventEmitter<any> = new EventEmitter();
  @Output() changeTab: EventEmitter<string> = new EventEmitter();
  @ViewChild(Select2Directive) select2Directive = null
  itemTitle: string = i18n.invoice.add_new_item; //'Add New Item';
  addNewClientTitle: string = i18n.client.add_new_client; //'Add New Client';

  quoteForm: FormGroup;
  deliverables: FormArray;
  deliverableForm: FormGroup;
  submitted: boolean = false;
  projectTypes: object[] = [
    { value: 'fixed', 'label': $localize`:@@ts.common.fixed:Fixed` },
    { value: 'hourly', 'label': $localize`:@@ts.common.hourly:Hourly` },
  ];
  defaultPaymentInfo: any = {};
  clientListApi: string = ClientApi.list;
  currencyListApi: any = GeneralAPI.currencies;
  userInfo: any;
  selectedClient: any;
  quotationDetail: any;
  prevQuotation: boolean = false;
  qrCodeBase64: string = '';
  productAndServices: any;
  defaultAdditionalInfo: any;
  discountType: string = 'percentage';
  showSaveBtn: boolean = false;
  taxIncludeTypes: any = [
    { name: $localize`:@@ts.common.exclusive_of_tax:Exclusive of Tax`, id: '1' },
    { name: $localize`:@@ts.common.inclusive_of_tax:Inclusive of Tax`, id: '2' },
    { name: $localize`:@@ts.common.not_applicable:Not Applicable`, id: '3' },
  ];
  discountTypes: any = [
    { name: $localize`:@@ts.common.percentage:Percentage`, id: 'percentage' },
    { name: $localize`:@@ts.common.amount:Amount`, id: 'amount' },
  ];
  taxIncludesValues: any = 2;
  isTaxInvoice: boolean = false;
  selectedCurrency: any;
  commonData: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private quotationService: QuotationService,
    private userService: UserService,
    private sharedDataService: SharedDataService) {

  }

  ngOnInit() {
    this.quoteForm = this.fb.group(new QuotationForm(new Quotation()))
    this.deliverableForm = this.fb.group(new QuotationDeliverableForm(new QuotationDeliverable));

    this.quotationService.commonData().subscribe((data: any) => {
      this.commonData = data;
      console.log(data);
      this.quoteForm.get('quotation_number').setValue(data.next_quotation_number);
      if (data.tax_percent) {
        this.isTaxInvoice = true;
        this.quoteForm.get('tax_percent').setValue(parseFloat(data.tax_percent));
        this.quoteForm.get('include_tax').setValue(true);
        this.enableTax(true);
      }else {
        this.taxIncludeTypes = [{ name: $localize`:@@ts.common.not_applicable:Not Applicable`, id: '3' }];
        this.quoteForm.get('tax_type').setValue(3);
        // this.taxIncludeTypes.splice(0, 1);
      }

      this.selectedCurrency = {
        id: this.commonData?.currencies?.currency_code,
        currency_code: this.commonData?.currencies?.currency_code,
        currency_symbol: this.commonData?.currencies?.currency_symbol,
        currency_full_name: this.commonData?.currencies?.currency_full_name
      }
  
      this.userInfo.currency_symbol = this.selectedCurrency?.currency_symbol;
    });

    this.userService.getSetting({ key: ['payment_info', 'additional_info'] }).subscribe((data: any) => {
      this.quoteForm.get('additional_info').setValue(data.additional_info ? data.additional_info : '');
    })

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    })

    this.fetchProductAndServices();
    // if (this.isProPlan) {
    //   this.fetchProductAndServices();
    // } else {
    //   this.productAndServices = [{ 'id': '__add_new_items__', 'text': this.itemTitle }];
    // }
  }

  get taxInvoice() {
    if(this.taxAmount || (this.quotationDetail.tax_type == 1 || this.quotationDetail.tax_type == 2)){
      return true;
    }
    return false;
  }

  toggleSaveBtn() {
    this.showSaveBtn = true;
  }

  isTaxInclusive(event) {
    if (event == 1) {
      this.quoteForm.get('include_tax').setValue(true);
      // this.isTaxable(true)
    }
    if (event == 2) {
      this.quoteForm.get('include_tax').setValue(true);
      // this.isTaxable(true)
    }
    if (event == 3) {
      this.quoteForm.get('include_tax').setValue(false);
      this.isTaxable(false)
    }
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  changeDiscountType(event) {
    let discountAmount = this.quoteForm.get('discount');
    discountAmount.setValue(null);
    if (event != 'percentage') {
      discountAmount.clearValidators();
    } else {
      discountAmount.setValidators([Validators.min(0),Validators.max(100)]);
    }
    discountAmount.updateValueAndValidity();
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  isTaxable(value: boolean) {
    const deliverables = this.quoteForm.get('items') as FormArray;
    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }
    this.deliverableForm.controls.is_taxable.setValue(value ? 1 : 0);
    this.deliverables = deliverables;
  }

  onChangeCurrency(value: any) {
    if (value) {
      this.selectedCurrency = {
        id: value.currency_code,
        currency_code: value.currency_code,
        currency_symbol: value.currency_symbol,
        currency_full_name: value?.currency_full_name
      }
      this.userInfo.currency_symbol = this.selectedCurrency?.currency_symbol;
    }
  }
  
  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  fetchProductAndServices() {
    this.quotationService.getProductAndServices().subscribe((data: any) => {
      if (data.length) {
        data.unshift({ 'id': '__add_new_items__', 'text': this.itemTitle })
        this.productAndServices = data;
      } else {
        this.productAndServices = [{ 'id': '__add_new_items__', 'text': this.itemTitle }];
      }
    });
  }

  get prefTextColor() {
    return `${this.userInfo.preference.text_color} !important;`;
  }

  get totalAmount() {
    // let items = this.deliverables ? this.deliverables.value : [];
    // if (items && items.length > 0) {
    //   return items.reduce((a, b) => a + this.deliverableCost(b), 0);
    // }
    // return 0;
    if (this.quoteForm.get('discount').value > 0) {
      return ((this.quotationOriginalAmount) - (this.quotationDiscountAmount) + (this.quotationDeliveryFeeAmount));
    } else {

      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return this.quotationDeliveryFeeAmount + (items.reduce((a, b) => a + this.deliverableCost(b), 0));
      }
      return 0;

    }
  }

  get taxAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableTax(b), 0);
    }
    return 0;
  }

  get subTotal() {
    if (this.totalAmount) {

      let taxPercent = 0;
      if (this.quoteForm.get('include_tax').value)
        taxPercent = this.quoteForm.get('tax_percent').value;

      return taxPercent ? (this.totalAmount + this.totalAmount * taxPercent / 100) : this.totalAmount;
    }

    return 0;
  }

  deliverableTax(deliverable: any) {
    const quoteFormValues = this.quoteForm.value;
    return (quoteFormValues.include_tax && quoteFormValues.tax_percent && deliverable.is_taxable) ? (deliverable.quantity * deliverable.rate * quoteFormValues.tax_percent / 100) : 0;
  }

  openPreviewModal() {
    this.prevQuotation = true;
    this.quotationDetail = this.quoteForm.value;
    this.quotationDetail.client = this.selectedClient;
  }

  onChangeClient(value: any) {
    if (value) {
      if (value.id == '__add_new_items__') {
        this.select2Directive.clear();
        const modalRef = this.modalService.open(AddClientModalComponent);

        // Set id on modal dialog
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";

        modalRef.result.then(result => {
          this.selectedClient = {
            id: result.id,
            full_name: result.full_name,
            email: result.email
          }
          this.quoteForm.get('client_id').setValue(result.id);
        });
      } else {
        this.selectedClient = {
          id: value.id,
          full_name: value.full_name,
          email: value.email
        }
      }
    }
  }

  deliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;

    const quoteFormValues = this.quoteForm.value;
    if (!isNaN(value)) {
      if (quoteFormValues.include_tax && quoteFormValues.tax_percent && deliverableValues.is_taxable) {
        value = value + value * quoteFormValues.tax_percent / 100;
      }
      return value;
    }
    return 0;
  }

  changeDiscount(value: number) {
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  calculateOriginalAmount() {
    this.quoteForm.get('original_amount').setValue(this.newQuotationOriginalAmount);
  }

  calculateDiscountedAmount() {
    this.quoteForm.get('discounted_amount').setValue(this.newQuotationDiscountAmount);
  }

  get quotationOriginalAmount() {

    if (this.quoteForm.get('discount').value > 0) {
      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return items.reduce((a, b) => a + this.deliverableCost(b), 0);
      }
      return null;
    } else {
      return null;
    }
  }

  get quotationDiscountAmount() {
    let discountAmount = this.quoteForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      if (this.discountType != 'percentage') {
        return discountAmount;
      }
      return (((this.quotationOriginalAmount) / (100) * (discountAmount)));
    } else {
      return null;
    }


    // if (this.quoteForm.get('discount').value > 0) {
    //   return (((this.quotationOriginalAmount) / (100) * (this.quoteForm.get('discount').value)));
    // } else {
    //   return null;
    // }
  }

  get quotationDeliveryFeeAmount() {
    if (this.quoteForm.get('delivery_fee').value > 0) {
      return this.quoteForm.get('delivery_fee').value;
    } else {
      return null;
    }
  }

  newDeliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  get newSubTotalDeliverableCost(){
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.newDeliverableCost(b), 0);
    }
    return 0;
  }

  get newQuotationDiscountAmount() {
    let discountAmount = this.quoteForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      if (this.discountType != 'percentage') {
        return discountAmount;
      }
      return (((this.newSubTotalDeliverableCost) / (100) * (discountAmount)));
    }
    return 0;
  }

  get newQuotationOriginalAmount() {
    return (this.newSubTotalDeliverableCost - this.newQuotationDiscountAmount);
  }

  get newQuotationDeliveryFeeAmount() {
    if (this.quoteForm.get('delivery_fee').value > 0) {
      return this.quoteForm.get('delivery_fee').value;
    }
    return 0;
  }

  get newDeliverableTax() {
    const quoteFormValues = this.quoteForm.value;
    if (quoteFormValues.include_tax && quoteFormValues.tax_percent) {
      if (quoteFormValues.tax_type == 1) {
        return (this.newQuotationOriginalAmount * quoteFormValues.tax_percent / 100);
      } else if (quoteFormValues.tax_type == 2) {
        return (((this.newQuotationOriginalAmount) / (1 + quoteFormValues.tax_percent / 100)) * (quoteFormValues.tax_percent / 100))
      }
    }
    return 0;
  }

  get newQuotationTotal() {
    let value = this.newQuotationOriginalAmount;
    const quoteFormValues = this.quoteForm.value;
    if (quoteFormValues.include_tax && quoteFormValues.tax_percent) {
      if (quoteFormValues.tax_type == 3 || quoteFormValues.tax_type == 2) {
        value = value;
      // } else if (quoteFormValues.tax_type == 2) {
      //   value = value - (((value) / (1 + quoteFormValues.tax_percent / 100)) * (quoteFormValues.tax_percent / 100));
      } else {
        value = value + (value * quoteFormValues.tax_percent / 100);
      }      
    }
    return parseFloat(value + this.newQuotationDeliveryFeeAmount).toFixed(2);
  }

  changeTax(value) {
    if (value > 0) {
      this.quoteForm.get('include_tax').setValue(true);
    } else {
      this.quoteForm.get('include_tax').setValue(false);
    }
    const deliverables = this.quoteForm.get('items') as FormArray;

    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }

  }

  changeQuantity(deliverable, type) {
    let value = deliverable.controls.quantity.value;
    if (type == 'plus') {
      deliverable.controls.quantity.setValue(value + 1);
    } else if (type == 'minus' && value > 1) {
      deliverable.controls.quantity.setValue(value - 1);
    }
  }

  addDeliverable(form: FormGroup) {
    let items = this.deliverables ? this.deliverables.value : [];
    const index = items.findIndex((e) => e.title === form.value.title);
    if (index === -1) {
      const currentDeliverbles = this.quoteForm.get('items') as FormArray
      currentDeliverbles.push(
        this.fb.group(
          new QuotationDeliverableForm(new QuotationDeliverable(form.value))
        )
      )

      this.deliverables = this.quoteForm.get('items') as FormArray;

      setTimeout(() => {
        form.controls.is_taxable.setValue((this.quoteForm.controls.include_tax.value > 0) ? 1 : 0);
      }, 100);
    } else {
      this.changeQuantity(this.deliverables.controls[index], 'plus');
    }
    // document.getElementById('create-deliverable').querySelector('input').focus();
  }

  editDeliverable(form: FormGroup) {
    const modalRef = this.modalService.open(AddItemsComponent);
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "addNewItems";
    modalRef.componentInstance.formType = 'editDeliverable';
    modalRef.componentInstance.form = form;
    modalRef.componentInstance.formId = 'editDeliverable';
    // form.get('quantity').setValue(1);
    modalRef.result.then(result => {
      console.log(result);
    }, fallbackResult => {
      // this.onCancel.emit(this.form);
    });
  }

  removeDeliverable(index: number) {
    const currentDeliverbles = this.quoteForm.get('items') as FormArray

    currentDeliverbles.removeAt(index)
    this.deliverables = currentDeliverbles;
  }

  changeInputQuantityIfValueNullOrZero(deliverable) {
    let value = deliverable.controls.quantity.value;

    if (value == null || value <= 0) {
      deliverable.controls.quantity.setValue(1);
    }

  }

  changeInputQuantity(deliverable) {
    let value = deliverable.controls.quantity.value;
    if (deliverable?.value?.available_quantity < value  && deliverable?.value?.type == 'product') {
      Swal.fire({
        title: i18n.warning,
        text: i18n.invoice.out_of_stock,
        icon: 'warning'
      })
      deliverable.controls.quantity.setValue(deliverable?.value?.available_quantity);
    }

  }

  updateDeliverable(form: FormGroup) {
    form.controls.edit.setValue(false)
  }

  cancelEdit(form: FormGroup) {
    form.controls.edit.setValue(false);
  }

  enableTax(value: boolean) {
    let taxPercentControl = this.quoteForm.get('tax_percent');
    if (value) {
      taxPercentControl.setValidators([Validators.required]);
    } else {
      taxPercentControl.setValue(null);
      taxPercentControl.clearValidators();
    }
    taxPercentControl.updateValueAndValidity();

    const deliverables = this.quoteForm.get('items') as FormArray;

    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }

    this.deliverableForm.controls.is_taxable.setValue(value ? 1 : 0);
    this.deliverables = deliverables;
  }

  validate() {
    this.prevQuotation = false;
    this.showSaveBtn = false;
    let deliverables = this.quoteForm.get('items').value;
    if (deliverables.length == 0) {
      Swal.fire({
        title: i18n.warning,
        text: i18n.quote.please_add_deliverable,
        icon: 'warning'
      })
    } else {
      this.submitted = true;
      if (this.quoteForm.valid) {
        return true
      }
    }

    return false;
  }

  saveAsDraft() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(1);
      this.quoteForm.get('action').setValue('draft');
      this.submit();
    }
  }

  async saveAsPdf() {
    if (this.validate()) {
      try {
        this.quoteForm.get('is_draft').setValue(0);
        let data: any = await this.submit();

        (window as any).open(`${environment.baseUrl}/download/quotation/${data.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self', 'location=yes');
      } catch (err) {
        console.error('promise error')
      }
    }
  }

  saveAndEmail() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(QUOTE_ACTIONS.EMAIL);
      this.submit();
    }
  }

  saveAndWhatsapp() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(QUOTE_ACTIONS.WHATSAPP);
      this.submit();
    }
  }

  saveAndShareLink() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(QUOTE_ACTIONS.SHARE_LINK);
      this.submit();
    }
  }

  saveQuote() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(null);
      this.submit();
    }
  }

  private submit() {
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
    this.quoteForm.get('total_amount').setValue(this.newQuotationTotal);

    return new Promise((resolve, reject) => {
      this.loaderService.startLoading();

      let fd: any = this.quoteForm.value;
      fd.quotation_date = parseDate(fd.quotation_date);

      // // fd.total_amount = this.totalAmount;
      // // fd.sub_total = this.subTotal;

      // //To=Do - rename items to deliverables
      fd.deliverables = fd.items;
      delete fd.items;

      // Create Quotation
      this.quotationService.create(fd).subscribe((r) => {
        this.loaderService.stopLoading();

        let msg = i18n.quote.quote_saved;
        let result: any = r;

        if (fd.action == QUOTE_ACTIONS.WHATSAPP) {
          msg = i18n.quote.quote_saved_and_whatsapp;
        } else if (fd.action == QUOTE_ACTIONS.EMAIL) {
          msg = i18n.quote.quote_saved_and_email;
        } else if (fd.action == QUOTE_ACTIONS.SHARE_LINK) {
          msg = i18n.quote.quote_saved;
          // msg = result.url;
          // copyText(msg);
        }
        if (fd.action != QUOTE_ACTIONS.SHARE_LINK) {
          Swal.fire(i18n.done, msg, 'success').then(() => {
            if (result.url)
              this.generateQuotationLink(result.url);

            this.quoteForm = this.fb.group(new QuotationForm(new Quotation()))
            this.deliverables = this.quoteForm.get('items') as FormArray;

            this.onCreate.emit(fd.action);
          });
        } else {
          if (result.url) {
            this.generateQuotationLink(result.url);
          }
          this.quoteForm = this.fb.group(new QuotationForm(new Quotation()))
          this.deliverables = this.quoteForm.get('items') as FormArray;

          this.onCreate.emit(fd.action);
        }
        this.submitted = false;
        resolve(r);
      }, (err) => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;

            Object.keys(validationErrors).forEach((prop) => {
              this.quoteForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');

        // reject(err);
      })
    });
  }

  /**
   * This function is used to copy the Quotation preview URL to clipboard
   * @param quotationUrl : Quotation preview URL
   * @return void
   */
  generateQuotationLink(quotationUrl) {
    const modalRef = this.modalService.open(QuotationLinkModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "quick-payment";
    modalRef.componentInstance.quotationUrl = quotationUrl;
  }

  closeModel() {
    if (this.prevQuotation) {
      this.prevQuotation = false;
    } else {
      this.changeTab.emit('all-quotes')
    }
  }
}
